import requestApi from "../common/boxp_api_client";
import requestrApi from "../common/boxr_api_client";


const getRecencyListing = (params) => {
    return requestApi({
        url: "/recency_info",
        method: "GET",
        params,
    })
}
const getRecencyPopup = (params) => {
    return requestApi({
        url: "/recency_popup",
        method: "GET",
        params,
    })
}
const downloadCsv = (params) => {
    return requestrApi({
        url: "/user_compliances/list_recency_infos",
        method: "GET",
        params,
    })
}

const getEMailPdfReport = (params) => {
    return requestApi({
        url: "/get_recency_report_competency",
        method: "GET",
        params,
    })
}

export const RecencyComplianceServices = {

    getRecencyListing,
    getRecencyPopup,
    downloadCsv,
    getEMailPdfReport
}